import React from "react"
import Tippy from "@tippyjs/react"
import { useDrag } from "react-dnd-11"
import styles from "../style.module.css"
import { Icon } from '../../../../../../../index'
interface IconProps {
  "path": Array<number>,
  "element": object
}
const SvgComponent = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  const { path, element } = props
  const [, drag] = useDrag({
    item: {
      type: "docs",
      path,
      element,
      dropped: false,
      canDrop: true
    }
  })
  return (
    <span data-testid="table-drag-icon" className={styles['table-column-toolbarIcon']} ref={drag}>
      <Tippy placement="top" className="tippy-box-dark" offset={() => [0, 20]} content={<span data-testid="table-drag-icon-text" className={styles['scrte-table-tooltip-text']}>Hold and drag to move table</span>} >
        <span>
          <Icon version="v2" icon="DragAndDrop" size="small" />
        </span>
      </Tippy>
    </span>
  )
})

export default SvgComponent
